/**
 *  旅客退票类型规则
 * @param {*} arr
 */
export default function refundPsgsScopes(arr) {
    if (arr === void 0) {
        arr = [];
    }
    var fzytp = 0, zytp = 0;
    arr
        .reduce(function (p, n) { return p.concat(n); }, [])
        .forEach(function (item) {
        if (item === 'zytp')
            zytp += 1;
        if (item === 'fzytp')
            fzytp += 1;
    });
    if (fzytp !== 0 && zytp !== 0 && fzytp !== zytp) {
        return 'zytp';
    }
    if (fzytp !== 0 && zytp !== 0 && fzytp === zytp) {
        return 'fzytp';
    }
    if (fzytp === 0 && zytp) {
        return 'zytp';
    }
    if (fzytp && zytp === 0) {
        return 'fzytp';
    }
    return '';
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/refundPsgsScopes.js
// module id = null
// module chunks = 